import { createContext, useContext } from 'react';
import { AvatarContextModel } from './props';

const AvatarContext = createContext<AvatarContextModel | undefined>(undefined);
AvatarContext.displayName = 'AvatarContext';

const useAvatarContext = () => useContext(AvatarContext);

export { AvatarContext, useAvatarContext };
